export default __webpack_public_path__ + "img/publication/publication6_700.jpg";